export default __webpack_public_path__ + "static/media/Background_00001.c35fec1f.png";